<template>
  <WebsiteLayout>
    <!--    <template v-slot:app-navbar>-->
    <!--      &lt;!&ndash;      <ProfessionalAppNavBar />&ndash;&gt;-->
    <!--    </template>-->
    <div class="app-container hero">
      <div class="main-app-wrapper dashboard">
        <div class="professional-profile">
          <!--          <div class="div-block-110" v-if="'token' in userInfo">-->
          <!--            <a @click="goToBack" class="link-block-12 w-inline-block">-->
          <!--              <img-->
          <!--                src="@/assets/timeslot-images/arrow-left.svg"-->
          <!--                loading="lazy"-->
          <!--                alt=""-->
          <!--                class="image-24"-->
          <!--              />-->
          <!--              <div class="text-block-89">Back</div>-->
          <!--            </a>-->
          <!--          </div>-->
          <div class="profile-wrapper pro">
            <div class="div-block-61"></div>
            <div class="div-block-62 pro">
              <div class="div-block-63">
                <div class="image-wrapper">
                  <div class="image-wrap-head">
                    <img
                      :src="
                        singleProfessional.customerDisplayPicture ||
                          require('@/assets/timeslot-images/profileImg.svg')
                      "
                      loading="lazy"
                      width="100%"
                      height="100%"
                      alt=""
                      class="image-15"
                    />
                  </div>
                </div>
                <!--                :src="customerInfo.customerDisplayPicture"-->

                <!--                @/assets/timeslot-images/profile-pic.png-->
                <!--                :src="userInfo.customerDisplayPicture ||require('@/assets/timeslot-images/profile-pic.png')"-->
                <div class="div-block-64">
                  <div class="text-block-53">
                    {{ singleProfessional.customerName }}
                  </div>
                  <div class="text-block-54">
                    {{ singleProfessional.professionalSubCategory }}
                  </div>
                </div>
              </div>

              <div class="div-block-65">
                <div class="message-btn-wrapper" v-if="showMessageIcon()">
                  <div
                    data-w-id="8f605cf5-9d4d-f059-93fb-31619e549723"
                    class="link-block-6 w-inline-block"
                    @click="openMessage"
                  >
                    <img
                      src="@/assets/timeslot-images/messageNew.svg"
                      loading="lazy"
                      alt=""
                    />
                  </div>
                  <div class="text-block-103">Message</div>
                </div>

                <!--                <a href="#" class="link-block-6 w-inline-block">-->
                <!--                  <img-->
                <!--                    src="@/assets/timeslot-images/user1.svg"-->
                <!--                    loading="lazy"-->
                <!--                    alt=""-->
                <!--                /></a>-->
                <div class="more-btn-wrapper">
                  <div
                    data-hover="false"
                    data-delay="0"
                    class="dropdown-3 w-dropdown"
                    v-click-outside="onClickOutside"
                  >
                    <div
                      class="dropdown-toggle-5  w-dropdown-toggle"
                      @click="toggleShare"
                    >
                      <div class="link-block-6 last w-inline-block">
                        <img
                          src="@/assets/timeslot-images/more.svg"
                          loading="lazy"
                          alt=""
                        />
                      </div>
                    </div>
                    <div class="text-block-103-copy">More</div>
                    <nav
                      class="share-dropdown w--open w-dropdown-list"
                      v-if="share"
                    >
                      <div
                        @click="openProfile"
                        class="dropdown-link-2 w-dropdown-link"
                      >
                        Share profile
                      </div>
                      <!--                      <a href="#" class="dropdown-link-2 report w-dropdown-link"-->
                      <!--                        >Report profile</a-->
                      <!--                      >-->
                    </nav>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="profile-details">
            <div
              data-current="Tab 1"
              data-easing="ease"
              data-duration-in="300"
              data-duration-out="100"
              class="w-tabs"
            >
              <div class="tabs-menu-3 w-tab-menu">
                <a
                  data-w-tab="Tab 1"
                  @click="openOverview"
                  :class="
                    overview
                      ? 'booking-tab w-inline-block w-tab-link w--current'
                      : 'booking-tab w-inline-block w-tab-link'
                  "
                >
                  <div>Overview</div>
                </a>
                <a
                  data-w-tab="Tab 2"
                  @click="openReview"
                  :class="
                    review
                      ? 'booking-tab w-inline-block w-tab-link w--current'
                      : 'booking-tab w-inline-block w-tab-link'
                  "
                >
                  <div>Reviews</div>
                </a>
                <a
                  data-w-tab="Tab 3"
                  @click="openProfClasses"
                  :class="
                    profClasses
                      ? 'booking-tab w-inline-block w-tab-link w--current'
                      : 'booking-tab w-inline-block w-tab-link'
                  "
                >
                  <div>Classes</div>
                </a>
              </div>
              <div class="w-tab-content">
                <div
                  data-w-tab="Tab 1"
                  :class="overview ? 'w-tab-pane w--tab-active' : 'w-tab-pane'"
                >
                  <div class="div-block-66">
                    <div class="about-professional-wrapper">
                      <div>
                        <div class="text-block-55">Summary</div>
                        <p class="paragraph-5">
                          {{ singleProfessional.professionalSummary }}
                        </p>
                        <a
                          :href="singleProfessional.professionalLinkedinLink"
                          class="link-block-6 w-inline-block"
                          ><img
                            loading="lazy"
                            src="@/assets/timeslot-images/linkedin-1.svg"
                            alt=""
                        /></a>
                      </div>
                      <div class="div-block-68">
                        <div class="text-block-55">Location</div>
                        <p class="paragraph-5">
                          {{ singleProfessional.customerCountry }}
                        </p>
                      </div>
                      <div class="div-block-68">
                        <div class="text-block-55">Role</div>
                        <p class="paragraph-5-copy">
                          {{ singleProfessional.professionalSubCategory }}
                        </p>
                      </div>
                      <div class="div-block-68">
                        <div class="text-block-55">Industry</div>
                        <p class="paragraph-5-copy">
                          {{ singleProfessional.professionalCategory }}
                        </p>
                      </div>
                      <div class="div-block-68">
                        <div class="text-block-55">Experience Level</div>
                        <p class="paragraph-5-copy">
                          {{ singleProfessional.professionalExperienceLevel }}
                        </p>
                      </div>
                      <div class="div-block-68">
                        <div class="text-block-55">Share Profile</div>
                        <p
                          class="paragraph-5-copy"
                          @click="openProfile"
                          style="cursor:pointer;"
                        >
                          {{ professionalShareLink }}
                        </p>
                      </div>
                    </div>
                    <div class="div-block-67">
                      <div
                        data-current="Tab 1"
                        data-easing="ease"
                        data-duration-in="300"
                        data-duration-out="100"
                        class="w-tabs"
                      >
                        <div class="tabs-menu-4 w-tab-menu">
                          <a
                            data-w-tab="Tab 1"
                            @click="openOneTime"
                            :class="
                              oneTime
                                ? 'booking-tab w-inline-block w-tab-link w--current'
                                : 'booking-tab w-inline-block w-tab-link'
                            "
                          >
                            <div>One-time</div>
                          </a>
                          <a
                            data-w-tab="Tab 2"
                            @click="openSubscription"
                            :class="
                              subscription
                                ? 'booking-tab w-inline-block w-tab-link w--current'
                                : 'booking-tab w-inline-block w-tab-link'
                            "
                          >
                            <div>Subscription</div>
                          </a>
                          <a
                            data-w-tab="Tab 3"
                            @click="openClasses"
                            :class="
                              classes
                                ? 'booking-tab w-inline-block w-tab-link w--current'
                                : 'booking-tab w-inline-block w-tab-link'
                            "
                          >
                            <div>Classes</div>
                          </a>
                        </div>
                        <div class="w-tab-content">
                          <div
                            data-w-tab="Tab 1"
                            v-if="oneTime"
                            :class="
                              oneTime
                                ? 'w-tab-pane w--tab-active'
                                : 'w-tab-pane'
                            "
                          >
                            <div>
                              <div class="div-block-69">
                                <div class="text-block-56">
                                  Available Sessions
                                </div>

                                <div class="text-block-57">
                                  Time zone-
                                  <strong>{{
                                    customerInfo.customerTimezone
                                  }}</strong
                                  >&nbsp;
                                  <div
                                    data-w-id="bc632ff5-f975-1dd3-f97c-3310cedd62c8"
                                    class="link-8"
                                    @click="openTime"
                                  >
                                    Update
                                  </div>
                                </div>
                              </div>
                              <div
                                class="div-block-70"
                                v-if="daysDates.length > 0"
                              >
                                <div
                                  :class="
                                    firstDay === index
                                      ? 'div-block-71-active w-inline-block'
                                      : 'div-block-71 w-inline-block'
                                  "
                                  @click="openFirst(day, index), (isActive = 0)"
                                  v-for="(day, index) in daysDates"
                                  :key="index"
                                >
                                  <div class="text-block-58">
                                    {{
                                      new Date(day).toDateString().slice(0, 3)
                                    }}
                                  </div>
                                  <div class="text-block-59">
                                    {{ `${new Date(day).getDate()}` }}
                                    {{
                                      `${new Date(day)
                                        .toDateString()
                                        .slice(4, 7)}`
                                    }}
                                  </div>
                                  <div
                                    class="text-block-58-copy"
                                    v-if="dayDetails[index].length > 1"
                                  >
                                    {{ dayDetails[index].length }} sessions
                                  </div>
                                  <div class="text-block-58-copy" v-else>
                                    {{ dayDetails[index].length }} session
                                  </div>
                                </div>

                                <div
                                  class="link-block-7 w-inline-block"
                                  @click="openDate"
                                >
                                  <div><strong>View all</strong></div>
                                </div>
                              </div>

                              <div
                                class="div-block-70 empty-message-slot"
                                v-else
                              >
                                <strong>No available sessions</strong>
                              </div>

                              <div class="div-block-69-copy-2">
                                <div class="text-block-56">
                                  Available time slots
                                </div>
                                <div class="text-block-57-copy">
                                  Select
                                  <strong>one</strong> slot
                                </div>
                              </div>

                              <div
                                class="empty-times"
                                v-if="daysDates.length === 0"
                              >
                                <strong>No time slots available</strong>
                              </div>
                              <div
                                class="time-grid"
                                v-if="
                                  loader.nonBlockingLoader &&
                                    daysDates.length > 0
                                "
                              >
                                <div
                                  class="div-block-72 w-inline-block skeleton-load"
                                ></div>
                                <div
                                  class="div-block-72 w-inline-block skeleton-load"
                                ></div>
                                <div
                                  class="div-block-72 w-inline-block skeleton-load"
                                ></div>
                                <div
                                  class="div-block-72 w-inline-block skeleton-load"
                                ></div>
                              </div>
                              <div class="time-grid" v-else>
                                <div
                                  v-for="(detail, index) in dailyTimeGroups"
                                  :key="index"
                                  @click="getActionDiv(index)"
                                >
                                  <div
                                    :class="
                                      index === isActive
                                        ? 'div-block-72-active w-inline-block'
                                        : 'div-block-72 w-inline-block'
                                    "
                                    @click="showSlots(detail)"
                                  >
                                    {{
                                      formattedDate(
                                        new Date(detail.availableTimeStartTime)
                                      )
                                    }}
                                    -
                                    {{
                                      formattedDate(
                                        new Date(detail.availableTimeEndTime)
                                      )
                                    }}
                                  </div>
                                </div>
                              </div>
                              <div
                                data-w-id="74675eb9-7d05-b354-322e-17fb59704c9c"
                                class="button-14 w-button"
                                @click="openBookingTime"
                                v-if="daysDates.length > 0"
                              >
                                Book Session
                              </div>
                              <div
                                v-else
                                data-w-id="74675eb9-7d05-b354-322e-17fb59704c9c"
                                class="button-14 w-button"
                              >
                                No session available
                              </div>
                            </div>
                          </div>
                          <div
                            data-w-tab="Tab 2"
                            v-if="subscription"
                            :class="
                              subscription
                                ? 'w-tab-pane w--tab-active'
                                : 'w-tab-pane'
                            "
                          >
                            <div>
                              <div class="subscription">
                                <div class="subscription-frequency-wrapper">
                                  <div class="frequency-text">
                                    Select Frequency
                                  </div>
                                  <div
                                    class="frequency-group"
                                    v-if="
                                      profSubscriptions.hasOwnProperty(
                                        'weeklySubscriptionAmount'
                                      ) ||
                                        profSubscriptions.hasOwnProperty(
                                          'monthlySubscriptionAmount'
                                        )
                                    "
                                  >
                                    <div
                                      class="frequency-container"
                                      v-if="
                                        profSubscriptions.hasOwnProperty(
                                          'weeklySubscriptionAmount'
                                        )
                                      "
                                    >
                                      <input
                                        type="radio"
                                        id="subscription-2"
                                        name="subscription-type"
                                        value="Weekly"
                                        v-model="picked"
                                      />
                                      <label for="subscription-2"
                                        >${{
                                          profSubscriptions.weeklySubscriptionAmount
                                        }}/week</label
                                      >
                                    </div>
                                    <div
                                      class="frequency-container"
                                      v-if="
                                        profSubscriptions.hasOwnProperty(
                                          'monthlySubscriptionAmount'
                                        )
                                      "
                                    >
                                      <input
                                        type="radio"
                                        id="subscription-1"
                                        name="subscription-type"
                                        v-model="picked"
                                        value="Monthly"
                                      />
                                      <label for="subscription-1"
                                        >${{
                                          profSubscriptions.monthlySubscriptionAmount
                                        }}/month</label
                                      >
                                    </div>
                                  </div>
                                  <div v-else>
                                    No frequency set
                                  </div>
                                </div>
                                <div class="text-block-56">
                                  Set preferred schedule
                                </div>
                                <div class="text-block-57-slot">
                                  These are the days and times during the month
                                  you’ll have a booking with
                                  <strong>{{
                                    singleProfessional.customerName
                                  }}</strong
                                  >.<br />Select a
                                  <strong>maximum of 3 days</strong>
                                </div>
                                <div class="div-block-172">
                                  <div
                                    data-w-id="53b89ce0-8c44-43db-13b5-2beeb96d7f7a"
                                    :class="
                                      daysIndex.includes(index) &&
                                      selectedDaysList.length <= 3
                                        ? 'sunday-active w-inline-block'
                                        : 'sunday w-inline-block'
                                    "
                                    v-for="(day, index) in daysData"
                                    :key="index"
                                    @click="selectedDays(day, index)"
                                  >
                                    <div
                                      data-w-id="53b89ce0-8c44-43db-13b5-2beeb96d7f7b"
                                      class="sunday-text"
                                    >
                                      {{ day.dayFirstLetter }}
                                    </div>
                                  </div>
                                </div>
                                <div
                                  class="div-block-69-copy-3 subscription-div"
                                >
                                  <div class="text-block-56">
                                    Select one slot
                                  </div>
                                  <div
                                    class="empty-times"
                                    v-if="subSlots.length === 0"
                                  >
                                    <strong
                                      >There are no timeslots to view</strong
                                    >
                                  </div>
                                  <div
                                    class="time-grid"
                                    v-if="
                                      loader.nonBlockingLoader &&
                                        subSlots.length > 0
                                    "
                                  >
                                    <div
                                      class="div-block-72 w-inline-block skeleton-load"
                                    ></div>
                                    <div
                                      class="div-block-72 w-inline-block skeleton-load"
                                    ></div>
                                    <div
                                      class="div-block-72 w-inline-block skeleton-load"
                                    ></div>
                                    <div
                                      class="div-block-72 w-inline-block skeleton-load"
                                    ></div>
                                  </div>
                                  <div class="time-grid" v-else>
                                    <div
                                      v-for="(detail, index) in subSlots"
                                      :key="index"
                                      @click="getActionDiv(index)"
                                    >
                                      <div
                                        :class="
                                          index === isActive
                                            ? 'div-block-72-active w-inline-block'
                                            : 'div-block-72 w-inline-block'
                                        "
                                        @click="showSubSlots(detail)"
                                      >
                                        {{
                                          detail.availableTimeStartTime.slice(
                                            0,
                                            5
                                          )
                                        }}{{
                                          amPm(detail.availableTimeStartTime)
                                        }}
                                        -
                                        {{
                                          detail.availableTimeEndTime.slice(
                                            0,
                                            5
                                          )
                                        }}{{
                                          amPm(detail.availableTimeEndTime)
                                        }}
                                      </div>
                                    </div>
                                  </div>

                                  <!--                                  <div class="div-block-173">-->
                                  <!--                                    <FormulateInput-->
                                  <!--                                      type="time"-->
                                  <!--                                      value="00:00"-->
                                  <!--                                      placeholder="00.00"-->
                                  <!--                                    />-->
                                  <!--                                    <div class="to-alignment">to</div>-->
                                  <!--                                    <FormulateInput-->
                                  <!--                                      type="time"-->
                                  <!--                                      value="00:00"-->
                                  <!--                                      placeholder="00.00"-->
                                  <!--                                    />-->
                                  <!--                                  </div>-->
                                </div>
                              </div>
                              <div
                                data-w-id="d6d8e08a-4db7-1e83-23e6-0d10d7ba9b14"
                                class="button-14 subscription-button w-button"
                                v-if="subSlots.length > 0"
                                @click="openConfirmSubscription"
                              >
                                Subscribe
                              </div>
                              <div
                                v-else
                                data-w-id="74675eb9-7d05-b354-322e-17fb59704c9c"
                                class="button-14 w-button"
                              >
                                No slots available
                              </div>
                            </div>
                          </div>
                          <div
                            data-w-tab="Tab 3"
                            v-if="classes"
                            :class="
                              classes
                                ? 'w-tab-pane w--tab-active'
                                : 'w-tab-pane'
                            "
                          >
                            <div class="div-block-194">
                              <div class="div-block-192">
                                <div class="div-block-193">
                                  <div
                                    class="myclass-empty-state"
                                    v-if="upcomingClasses.length === 0"
                                  >
                                    <div class="div-block-19">
                                      <img
                                        loading="lazy"
                                        src="@/assets/timeslot-images/myclass.svg"
                                        alt=""
                                        class="image-6"
                                      />
                                      <div class="text-block-20">
                                        Nothing to show here
                                      </div>
                                      <div class="text-block-21">
                                        <strong>{{
                                          singleProfessional.customerName
                                        }}</strong>
                                        has no class added at the moment
                                      </div>
                                    </div>
                                  </div>
                                  <div v-else>
                                    <div
                                      class="div-block-196"
                                      v-for="(singleProfClass,
                                      index) in upcomingClasses"
                                      :key="index"
                                    >
                                      <h4 class="heading-26">
                                        {{ singleProfClass.groupSessionTopic }}
                                      </h4>
                                      <div class="div-block-195">
                                        <div class="div-block-23">
                                          <img
                                            loading="lazy"
                                            src="@/assets/timeslot-images/calendar.svg"
                                            alt=""
                                            class="image-7"
                                          />
                                          <div>
                                            {{
                                              new Date(
                                                singleProfClass.groupSessionStartTime.slice(
                                                  0,
                                                  10
                                                )
                                              )
                                                .toString()
                                                .slice(0, 11)
                                            }}
                                          </div>
                                        </div>
                                        <div class="div-block-23">
                                          <img
                                            loading="lazy"
                                            src="@/assets/timeslot-images/money.svg"
                                            alt=""
                                            class="image-7"
                                          />
                                          <div>
                                            ${{
                                              singleProfClass.groupSessionAmount
                                            }}
                                          </div>
                                        </div>
                                        <div class="div-block-23">
                                          <img
                                            loading="lazy"
                                            src="@/assets/timeslot-images/Frame.svg"
                                            alt=""
                                            class="image-7"
                                          />
                                          <div>
                                            {{
                                              singleProfClass.groupSessionMaxAttendance
                                            }}
                                            students
                                          </div>
                                        </div>
                                      </div>
                                      <div
                                        data-w-id="8377695a-a7bc-372c-4ab5-545356bb9da5"
                                        v-if="
                                          !showLoading ||
                                            activeIndex !==
                                              singleProfClass.groupSessionId
                                        "
                                        @click="
                                          openClassDetail(singleProfClass)
                                        "
                                        class="timeslot-button class w-button"
                                      >
                                        View class details
                                      </div>
                                      <div
                                        data-w-id="8377695a-a7bc-372c-4ab5-545356bb9da5"
                                        v-if="
                                          showLoading &&
                                            activeIndex ===
                                              singleProfClass.groupSessionId
                                        "
                                        class="timeslot-button class w-button"
                                      >
                                        Loading class details
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  data-w-tab="Tab 2"
                  :class="review ? 'w-tab-pane w--tab-active' : 'w-tab-pane'"
                >
                  <div class="div-block-66-copy">
                    <div class="reviews-wrapper">
                      <div
                        class="empty-message-container"
                        v-if="reviews.length === 0"
                      >
                        <img
                          src="@/assets/timeslot-images/Notification.svg"
                          width="50"
                          height="50"
                        />
                        <div class="new-message">Nothing to show here</div>
                        <div class="new-message-sub">
                          Professional has no reviews
                        </div>
                        <!--                        <router-link to="/discover-professionals" class="timeslot-button w-button">Discover professionals</router-link>-->
                      </div>
                      <div v-else>
                        <div
                          class="review-block"
                          v-for="(review, index) in reviews"
                          :key="index"
                        >
                          <div class="user-heading">
                            <div class="div-block-74">
                              <img
                                width="65"
                                height="65"
                                style="border-radius: 50%;"
                                loading="lazy"
                                :src="review.customerDisplayPicture"
                                alt=""
                                class="image-16"
                              />
                              <div>
                                <div class="text-block-60">
                                  {{ review.customerName }}
                                </div>
                                <div class="text-block-61">
                                  {{ review.customerInterest }}
                                </div>
                              </div>
                            </div>
                            <div class="div-block-75">
                              <!--                              <div class="text-block-62">2 hours ago</div>-->
                            </div>
                          </div>
                          <div class="div-block-76">
                            <p class="paragraph-6">
                              {{ review.bookingProfessionalReview }}
                              <!--                              <span class="text-span-4">Read More</span>-->
                            </p>
                            <p class="paragraph-6">
                              Rating: {{ review.bookingProfessionalRating }}/5.0
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="div-block-67-copy">
                      <img
                        width="130"
                        loading="lazy"
                        src="@/assets/timeslot-images/Frame-34223.png"
                        alt=""
                      />
                      <div class="text-block-65">Comment</div>
                      <div class="text-block-66">
                        Write a review on your experience with
                        <strong>{{ singleProfessional.customerName }}</strong>
                      </div>
                      <div class="button-16 w-button" @click="reviewChange">
                        Drop a review
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  data-w-tab="Tab 3"
                  :class="
                    profClasses ? 'w-tab-pane w--tab-active' : 'w-tab-pane'
                  "
                >
                  <div
                    class="myclass-empty-state"
                    v-if="professionalClasses.length === 0"
                  >
                    <div class="div-block-19">
                      <img
                        src="@/assets/timeslot-images/myclass.svg"
                        loading="lazy"
                        alt=""
                        class="image-6"
                      />
                      <div class="text-block-20">Nothing to show here</div>
                      <div class="text-block-21">
                        You do not have any class created yet
                      </div>
                    </div>
                  </div>
                  <div class="class-card-block" v-else>
                    <div
                      class="w-layout-grid class-card"
                      @click="goToClassDetails(groupSession.groupSessionId)"
                      v-for="(groupSession, index) in professionalClasses"
                      :key="index"
                    >
                      <div
                        id="w-node-_9ade9d8b-dee7-65d3-7682-169b0d1f7ae5-8f09cdd5"
                        class="card-image-block"
                      >
                        <div>
                          <!--                          <div class="text-block-112"> {{ groupSession.professionalName }}</div>-->
                          <div class="card-header-class">
                            {{ groupSession.groupSessionTopic }}
                          </div>
                        </div>
                      </div>
                      <div
                        id="w-node-_9ade9d8b-dee7-65d3-7682-169b0d1f7aeb-8f09cdd5"
                        class="content"
                      >
                        <div class="card-content-header">
                          <div class="date-block" style="padding-right:0;">
                            <!--                            <div class="class_title">-->
                            <!--                              {{ groupSession.groupSessionTopic }}-->
                            <!--                            </div>-->
                          </div>
                          <div class="div-block-247">
                            <div class="attendance_count">
                              {{ groupSession.groupSessionCurrentAttendees }}/{{
                                groupSession.groupSessionMaxAttendance
                              }}
                              Learners
                            </div>
                          </div>
                        </div>
                        <!--                        <div class="prof-content">-->
                        <!--                          <div class="prof-image-block">-->
                        <!--                            <img width="55" loading="lazy" src="@/assets/timeslot-images/Avatar3.svg" alt=""></div>-->
                        <!--                          <div>-->
                        <!--                            <div class="prof-name"> {{ groupSession.professionalName }}</div>-->
                        <!--                            <div class="prof-title">{{ groupSession.professionalCategory }}</div>-->
                        <!--                          </div>-->
                        <!--                        </div>-->
                        <div class="line"></div>
                        <div class="date">
                          <div class="date-block">
                            <img
                              loading="lazy"
                              src="@/assets/timeslot-images/calendar1.svg"
                              alt=""
                            />
                            <div class="date-tect">
                              {{
                                new Date(
                                  groupSession.groupSessionStartTime.slice(
                                    0,
                                    10
                                  )
                                )
                                  .toString()
                                  .slice(0, 11)
                              }}
                            </div>
                          </div>
                          <div class="time-block">
                            <img
                              loading="lazy"
                              src="@/assets/timeslot-images/clock1.svg"
                              alt=""
                            />
                            <div class="time-range">
                              {{
                                formatHours(
                                  new Date(groupSession.groupSessionStartTime)
                                )
                              }}:{{
                                formatMinutes(
                                  new Date(groupSession.groupSessionStartTime)
                                )
                              }}
                              {{
                                formatTime(
                                  new Date(groupSession.groupSessionStartTime)
                                )
                              }}
                              -
                              {{
                                formatHours(
                                  new Date(groupSession.groupSessionEndTime)
                                )
                              }}:{{
                                formatMinutes(
                                  new Date(groupSession.groupSessionEndTime)
                                )
                              }}
                              {{
                                formatTime(
                                  new Date(groupSession.groupSessionEndTime)
                                )
                              }}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <SignUpWarningModal
          :buttonAction="goToSignUp"
          v-if="signUpModal"
          :cancel="closeSignUpModal"
        />
        <UpdateTimezoneModal v-if="time" :cancel="closeTime" />
        <MessageRequestModal
          v-if="message && !messageRequestSuccess"
          :cancel="closeMessage"
        />
        <ConfirmBookingModal
          v-if="confirm && !bookingSuccess"
          :cancel="closeConfirm"
          :change="openChangeDate"
        />
        <BookingRequestedModal
          v-if="bookingSuccess"
          :cancel="closeRequest"
          :go-to-booking="goToBooking"
        />
        <SelectDateModal
          v-if="date"
          :cancel="closeDate"
          :trigger="triggerUpdate"
          :open-time-group="triggerGroup"
        />
        <!--      <SelectTimeModal-->
        <!--        v-if="bookingTime"-->
        <!--        :cancel="closeBookingTime"-->
        <!--        :trigger="triggerConfirmBooking"-->
        <!--        :show-date-modal="triggerDate"-->
        <!--      />-->
        <SelectTimeGroupModal
          v-if="group"
          :cancel="closeGroup"
          :trigger="triggerTime"
          :show-date-modal="triggerDateClose"
        />
        <ShareProfileModal v-if="profile" :cancel="closeProfile" />
        <SuccessMessageModal
          v-if="messageRequestSuccess"
          :message="successMessage"
          :cancel="closeMessageRequestSuccess"
          :button-action="closeMessageRequestSuccess"
        />
        <ConfirmSubscriptionModal
          v-if="subscriptionConfirm && !subscriptionSuccess"
          :cancel="closeConfirmSubscription"
          :days="subShortDays"
          :sub-type="picked"
          :change="openChangeDateSub"
          :daysList="subDays"
        />
        <SubscriptionRequestedModal
          v-if="subscriptionSuccess"
          :days="subShortDays"
          :subscriptions="goToSubscriptions"
          :cancel="closeSubRequestedModal"
        />
        <!--      <ReviewModal-->
        <!--        v-if="reviewComment"-->
        <!--        :cancel="closeReview"-->
        <!--        :button-action="closeReview"-->
        <!--        :prof-name="singleProfessional.customerName"-->
        <!--      />-->
        <ReviewRestrictionModal
          v-if="reviewRestrict"
          :cancel="closeRestrictionModal"
        />
        <ReviewToBookingModal
          v-if="canReview"
          :button-action="reviewBookings"
        />
        <ClassDetailsModal
          v-if="classDetails"
          :prof-name="singleProfessional.customerName"
          :cancel="closeClassDetail"
        />
        <ClassBookedModal
          v-if="classBookedSuccess"
          :prof-name="singleProfessional.customerName"
          :cancel="closeClassSuccess"
        />
      </div>
    </div>
  </WebsiteLayout>
</template>

<script>
import WebsiteLayout from "@/components/layout/WebsiteLayout";
import MessageRequestModal from "@/components/modal/MessageRequestModal";
import ConfirmBookingModal from "@/components/modal/ConfirmBookingModal";
import BookingRequestedModal from "@/components/modal/BookingRequestedModal";
import UpdateTimezoneModal from "@/components/modal/UpdateTimezoneModal";
import ProfessionalRequest from "@/model/requests/ProfessionalRequest";
import StoreUtils from "@/utils/BaseUtils/StoreUtils";
import { mapState } from "vuex";
import SelectDateModal from "@/components/modal/SelectDateModal";
// import SelectTimeModal from "@/components/modal/SelectTimeModal";
import AvailableTimeRequest from "@/model/requests/AvailableTimeRequest";
import NotificationRequest from "@/model/requests/NotificationRequest";
import moment from "moment";
import CustomerRequest from "@/model/requests/CustomerRequest";
import SelectTimeGroupModal from "@/components/modal/SelectTimeGroupModal";
import ShareProfileModal from "@/components/modal/ShareProfileModal";
import SuccessMessageModal from "@/components/modal/SuccessMessageModal";
import ConfirmSubscriptionModal from "@/components/modal/ConfirmSubscriptionModal";
import SubscriptionRequestedModal from "@/components/modal/SubscriptionRequestedModal";
// import ProfessionalAppNavBar from "@/components/navbar/ProfessionalAppNavBar";
// import ReviewModal from "@/components/modal/ReviewModal";
import RouterUtils from "@/utils/BaseUtils/RouterUtils";
import ReviewRequest from "@/model/requests/ReviewRequest";
import ReviewToBookingModal from "@/components/modal/ReviewToBookingModal";
import ReviewRestrictionModal from "@/components/modal/ReviewRestrictionModal";
import ClassDetailsModal from "@/components/modal/ClassDetailsModal";
import ClassBookedModal from "@/components/modal/ClassBookedModal";
import GroupSessionRequest from "@/model/requests/GroupSessionRequest";
import SignUpWarningModal from "@/components/modal/SignUpWarningModal";
import Router from "@/router/router";

export default {
  name: "ProfessionalProfile",
  components: {
    SignUpWarningModal,
    ClassBookedModal,
    ClassDetailsModal,
    UpdateTimezoneModal,
    WebsiteLayout,
    MessageRequestModal,
    ConfirmBookingModal,
    BookingRequestedModal,
    SelectDateModal,
    // SelectTimeModal,
    SelectTimeGroupModal,
    ShareProfileModal,
    SuccessMessageModal,
    ConfirmSubscriptionModal,
    SubscriptionRequestedModal,
    // ProfessionalAppNavBar,
    // ReviewModal,
    ReviewToBookingModal,
    ReviewRestrictionModal
  },
  data() {
    return {
      signUpModal: false,
      bar: true,
      cross: false,
      firstDay: 0,
      dayIndex: -1,
      selectedDaysList: [],
      daysIndex: [],
      subscriptionRequest: false,
      subscriptionConfirm: false,
      successMessage: "Your message request has been sent successfully",
      success: true,
      share: false,
      profile: false,
      message: false,
      confirm: false,
      request: false,
      time: false,
      overview: true,
      review: false,
      readProfModel: ProfessionalRequest.readBy,
      date: false,
      bookingTime: false,
      readModel: AvailableTimeRequest.readByProfessionalId,
      availableModel: AvailableTimeRequest.readCount,
      first: true,
      second: false,
      third: false,
      datesModel: AvailableTimeRequest.readDates,
      dayModel: AvailableTimeRequest.readByDate,
      slotModel: AvailableTimeRequest.readByAvailableTimeGroupId,
      readCustomerModel: CustomerRequest.readBy,
      daysModel: AvailableTimeRequest.readNextDays,
      activeTime: true,
      isActive: 0,
      group: false,
      oneTime: true,
      subscription: false,
      classes: false,
      daysData: [
        {
          dayFirstLetter: "S",
          day: "Sunday",
          shortForm: "Sun"
        },
        {
          dayFirstLetter: "M",
          day: "Monday",
          shortForm: "Mon"
        },
        {
          dayFirstLetter: "T",
          day: "Tuesday",
          shortForm: "Tue"
        },
        {
          dayFirstLetter: "W",
          day: "Wednesday",
          shortForm: "Wed"
        },
        {
          dayFirstLetter: "T",
          day: "Thursday",
          shortForm: "Thur"
        },
        {
          dayFirstLetter: "F",
          day: "Friday",
          shortForm: "Fri"
        },
        {
          dayFirstLetter: "S",
          day: "Saturday",
          shortForm: "Sat"
        }
      ],
      refModel: ProfessionalRequest.readReference,
      reviewComment: false,
      readSubModel: ProfessionalRequest.readSubscriptionPlans,
      readSubTimeModel: AvailableTimeRequest.readSubscriptionTime,
      picked: "",
      reviewListModel: ReviewRequest.readByProfessionalId,
      canReview: false,
      reviewRestrict: false,
      classDetails: false,
      classSuccess: false,
      readClassesModel: GroupSessionRequest.readByProfessionalId,
      readClassModel: GroupSessionRequest.readByGroupSessionId,
      showLoading: false,
      activeIndex: null,
      profClasses: false
    };
  },
  props: {},
  methods: {
    showMessageIcon() {
      if (Object.keys(this.userInfo).length === 0) {
        return false;
      } else {
        if ("professional" in this.userInfo) {
          if (
            this.singleProfessional.professionalId ===
            this.userInfo.professional.professionalId
          ) {
            return false;
          } else {
            return true;
          }
        } else {
          return true;
        }
      }
    },
    // formattedDate(date) {
    //   return moment(date).format("LT");
    // },
    formatDate(date) {
      return moment(date).format("ll");
    },
    formatTime(date) {
      return moment(date).format("a");
    },
    formatMinutes(date) {
      return moment(date).format("mm");
    },
    formatHours(date) {
      return moment(date).format("h");
    },
    goToClassDetails(value) {
      RouterUtils.changeRouteUrlTo(`/class-details/${value}`);
    },
    goToSignUp() {
      let targetUrl = this.$route.path;
      sessionStorage.setItem("target", targetUrl);
      RouterUtils.changeRouteUrlTo("/get-started");
    },

    showNav() {
      this.cross = true;
      this.bar = false;
    },
    closeNav() {
      this.bar = true;
      this.cross = false;
    },
    goToProfile() {
      let professionalId = this.$route.params.id;
      RouterUtils.changeRouteUrlTo(`/professionals/${professionalId}`);
    },
    logout() {
      StoreUtils.dispatch(StoreUtils.actions.auth.LOGOUT);
    },
    goToBooking() {
      RouterUtils.changeRouteUrlTo("/customer-bookings");
      let customerId = this.userInfo.customerId;
      StoreUtils.dispatch("notificationMessage/readNotifications", {
        notificationRecipient: customerId
      });
      StoreUtils.commit("booking/updateBookingSuccess", false);
    },
    goToSubscriptions() {
      RouterUtils.changeRouteUrlTo("/customer-subscriptions");
      let customerId = this.userInfo.customerId;
      StoreUtils.dispatch("notificationMessage/readNotifications", {
        notificationRecipient: customerId
      });
      StoreUtils.commit("subscription/setSubscriptionSuccess", false);
    },
    closeSubRequestedModal() {
      StoreUtils.commit("subscription/setSubscriptionSuccess", false);
    },
    amPm(value) {
      let timeValue = parseInt(value.slice(0, 2));
      if (timeValue >= 12) {
        return "PM";
      } else {
        return "AM";
      }
    },
    goToBack() {
      RouterUtils.goBackOnce();
    },
    closeMessageRequestSuccess() {
      let customerId = this.userInfo.customerId;
      StoreUtils.dispatch("notificationMessage/readNotifications", {
        notificationRecipient: customerId
      });
      StoreUtils.commit("messageRequest/updateMessageRequestSuccess", false);
      this.message = false;
    },
    closeSuccess() {
      this.success = false;
    },
    closeProfile() {
      this.profile = false;
    },
    openProfile() {
      this.profile = true;
    },
    formattedDate(date) {
      return moment(date).format("LT");
    },
    getActionDiv(obj) {
      this.isActive = obj;
    },
    getDayIndex(id) {
      this.dayIndex = id;
    },
    selectedDays(day, index) {
      let professionalId = this.$route.params.id;
      if (
        !this.daysIndex.includes(index) &&
        this.daysIndex.length < 3 &&
        this.selectedDaysList.length < 3
      ) {
        this.selectedDaysList.push(day);
        this.daysIndex.push(index);
        StoreUtils.commit(
          "availability/setSubscriptionDays",
          this.selectedDaysList
        );
        this.readSubTimeModel.daysOfWeek = this.subDays;
        this.readSubTimeModel.professionalId = professionalId;
        this.readSubTimeModel.subscriptionType = this.picked;
        StoreUtils.dispatch(
          "availability/readAvailableSubscriptionTime",
          this.readSubTimeModel
        ).then(() => {
          StoreUtils.commit(
            "availability/setSelectedSubSlot",
            this.subSlots[0]
          );
        });
      } else {
        this.selectedDaysList = this.selectedDaysList.filter(
          dayItem => dayItem.shortForm !== day.shortForm
        );
        this.daysIndex = this.daysIndex.filter(item => item !== index);
        StoreUtils.commit(
          "availability/setSubscriptionDays",
          this.selectedDaysList
        );
        this.readSubTimeModel.daysOfWeek = this.subDays;
        this.readSubTimeModel.professionalId = professionalId;
        this.readSubTimeModel.subscriptionType = this.picked;
        if (this.subDays.length > 0) {
          StoreUtils.dispatch(
            "availability/readAvailableSubscriptionTime",
            this.readSubTimeModel
          ).then(() => {
            StoreUtils.commit(
              "availability/setSelectedSubSlot",
              this.subSlots[0]
            );
          });
        } else {
          StoreUtils.commit("availability/setSubSlots", []);
        }

        return this.daysIndex;
      }
    },
    formattedStart(date) {
      return moment(date).format("L");
    },
    showSlots(value) {
      StoreUtils.commit("availability/setSelectedSlot", value);
    },
    showSubSlots(value) {
      StoreUtils.commit("availability/setSelectedSubSlot", value);
    },
    openFirst(value, index) {
      let professionalId = this.$route.params.id;
      this.dayModel.professionalId = professionalId;
      this.dayModel.date = value;
      this.firstDay = index;
      StoreUtils.commit("availability/setSelectedDate", value);
      StoreUtils.dispatch("availability/readByDate", this.dayModel).then(() => {
        StoreUtils.commit(
          "availability/setSelectedSlot",
          this.dailyTimeGroups[0]
        );
      });
    },
    toggleShare() {
      this.share = !this.share;
    },
    openMessage() {
      if (!("token" in this.userInfo)) {
        this.openSignUpModal();
      } else {
        this.message = true;
      }
    },
    closeMessage() {
      this.message = false;
    },
    openConfirm() {
      this.confirm = true;
    },
    closeConfirm() {
      this.confirm = false;
    },
    openRequest() {
      this.confirm = false;
      this.request = true;
    },
    closeRequest() {
      // this.request = false;
      this.confirm = false;
      StoreUtils.commit("booking/updateBookingSuccess", false);
    },
    openTime() {
      this.time = true;
    },
    closeTime() {
      this.time = false;
    },
    openReview() {
      this.overview = false;
      this.review = true;
      this.profClasses = false;
    },
    openOverview() {
      this.review = false;
      this.overview = true;
      this.profClasses = false;
    },
    openProfClasses() {
      this.overview = false;
      this.review = false;
      this.profClasses = true;
    },
    openOneTime() {
      this.oneTime = true;
      this.subscription = false;
      this.classes = false;
    },
    openSubscription() {
      this.subscription = true;
      this.oneTime = false;
      this.classes = false;
    },
    openClasses() {
      this.subscription = false;
      this.oneTime = false;
      this.classes = true;
    },
    openDate() {
      if (!("token" in this.userInfo)) {
        this.openSignUpModal();
      } else {
        this.date = true;
      }
    },
    closeDate() {
      this.date = false;
    },
    triggerUpdate() {
      this.time = true;
      this.date = false;
    },
    openSignUpModal() {
      this.signUpModal = true;
    },
    closeSignUpModal() {
      this.signUpModal = false;
    },
    openBookingTime() {
      if (!("token" in this.userInfo)) {
        this.openSignUpModal();
      } else {
        this.confirm = true;
      }
    },
    closeBookingTime() {
      this.bookingTime = false;
    },
    triggerConfirmBooking() {
      this.bookingTime = false;
      this.confirm = true;
    },
    triggerDate() {
      this.date = true;
      this.bookingTime = false;
    },
    triggerGroup() {
      this.date = false;
      this.group = true;
    },
    triggerTime() {
      this.group = false;
      // this.bookingTime = true;
      this.confirm = true;
    },
    closeGroup() {
      this.group = false;
    },
    triggerDateClose() {
      this.group = false;
      this.date = true;
    },
    openChangeDate() {
      this.confirm = false;
      this.date = true;
    },
    openChangeDateSub() {
      this.subscriptionConfirm = false;
      this.date = true;
    },
    closeConfirmSubscription() {
      this.subscriptionConfirm = false;
    },
    openConfirmSubscription() {
      if (!("token" in this.userInfo)) {
        this.openSignUpModal();
      } else {
        this.subscriptionConfirm = true;
      }
    },
    reviewChange() {
      if (this.pendingReviews.length > 0) {
        this.canReview = true;
      } else {
        this.reviewRestrict = true;
      }
      // this.reviewComment = true;
    },
    closeReview() {
      this.reviewComment = false;
    },
    reviewBookings() {
      if (this.userInfo.userRole.toLowerCase() === "customer") {
        RouterUtils.changeRouteUrlTo("/customer-bookings");
      } else {
        RouterUtils.changeRouteUrlTo("/professional-bookings");
      }
    },
    closeRestrictionModal() {
      this.reviewRestrict = false;
    },
    openClassDetail(value) {
      if (!("token" in this.userInfo)) {
        this.openSignUpModal();
      } else {
        this.readClassModel.groupSessionId = value.groupSessionId;
        this.showLoading = true;
        this.activeIndex = value.groupSessionId;
        StoreUtils.dispatch("groupSession/readByGroupSessionId").then(() => {
          this.classDetails = true;
          this.showLoading = false;
        });
      }
    },
    closeClassDetail() {
      this.classDetails = false;
    },
    openClassSuccess() {
      this.classSuccess = true;
    },
    closeClassSuccess() {
      StoreUtils.commit("groupSession/updateClassBookedSuccess", false);
    },
    onClickOutside() {
      if (this.share) {
        this.share = false;
      }
    }
  },
  computed: {
    ...mapState({
      userInfo: state => state.auth.userInfo,
      professionalInfo: state => state.professional.professionalInfo,
      singleProfessional: state => state.professional.singleProfessional,
      dailyTimeGroups: state => state.availability.dailyTimeGroups,
      availableDates: state => state.availability.availableDates,
      customerInfo: state => state.customer.customerInfo,
      availableDays: state => state.availability.availableDays,
      bookingSuccess: state => state.booking.bookingSuccess,
      messageRequestSuccess: state =>
        state.messageRequest.messageRequestSuccess,
      profSubscriptions: state => state.professional.profSubscriptions,
      reviews: state => state.professional.reviews,
      selectedDate: state => state.availability.selectedDate,
      subscriptionDays: state => state.availability.subscriptionDays,
      subSlots: state => state.availability.subSlots,
      subscriptionSuccess: state => state.subscription.subscriptionSuccess,
      professionals: state => state.professional.professionals,
      professionalId: state => state.professional.professionalId,
      pendingReviews: state => state.booking.pendingReviews,
      professionalClasses: state => state.groupSession.profGroupSessions,
      singleGroupSession: state => state.groupSession.singleGroupSession,
      classBookedSuccess: state => state.groupSession.classBookedSuccess,
      groupSessions: state => state.groupSession.groupSessions
    }),
    ...mapState(["loader"]),
    availableGroups() {
      return StoreUtils.rootGetters("availability/getAvailableGroups");
    },
    daysDates() {
      return Object.keys(this.availableDays);
    },
    dayDetails() {
      return Object.values(this.availableDays);
    },
    subDays() {
      let days = this.subscriptionDays;
      if (days.length > 0) {
        days = days.map(item => item.day.toLowerCase());
      }
      return days;
    },
    subShortDays() {
      let days = this.subscriptionDays;
      if (days.length > 0) {
        days = days.map(item => item.shortForm);
      }
      return days;
    },
    upcomingClasses() {
      return this.professionalClasses.filter(
        item => item.groupSessionStatus === "UPCOMING"
      );
    },
    professionalShareLink() {
      return `app.timeslate.com/professionals/${this.singleProfessional.professionalId}/${this.singleProfessional.professionalReference}`;
    }
    // daysString() {
    //   let days = this.subscriptionDays;
    //   if (days.length > 0) {
    //     days = days.map(item => item.shortForm);
    //   }
    //   let subDays = days.split("");
    //
    // }
  },
  watch: {
    monthly(newValue) {
      if (newValue === true) {
        this.readSubTimeModel.subscriptionType = "Monthly";
      }
    },
    weekly(newValue) {
      if (newValue === true) {
        this.readSubTimeModel.subscriptionType = "Weekly";
      }
    }
  },
  created() {},
  mounted() {
    let professionalId = this.$route.params.id;
    // this.readModel.availableTimeGroupProfessionalId = this.singleProfessional.professionalId;
    // StoreUtils.dispatch(
    //   StoreUtils.actions.availability.READ_BY_PROFESSIONAL_ID,
    //   this.readModel
    // );

    this.datesModel.professionalId = professionalId;
    StoreUtils.dispatch(
      StoreUtils.actions.availability.READ_DATES,
      this.datesModel
    );
    // setTimeout(() => {
    //   this.dayModel.professionalId = this.singleProfessional.professionalId;
    //   this.dayModel.availableTimeGroupDate = this.availableDates[0];
    //   StoreUtils.dispatch("availability/readByDay", this.dayModel);
    // }, 1000);

    // this.readCustomerModel.customerId = this.userInfo.customerId;
    // StoreUtils.dispatch(
    //   StoreUtils.actions.customer.UPDATE_CUSTOMER,
    //   this.readCustomerModel
    // );

    this.daysModel.professionalId = professionalId;
    StoreUtils.dispatch("availability/readNextDays", this.daysModel).then(
      () => {
        if (this.daysDates.length > 0) {
          this.dayModel.professionalId = professionalId;
          this.dayModel.date = this.daysDates[0];
          StoreUtils.dispatch("availability/readByDate", this.dayModel).then(
            () => {
              StoreUtils.commit(
                "availability/setSelectedSlot",
                this.dailyTimeGroups[0]
              );
            }
          );
          StoreUtils.commit("availability/setSelectedDate", this.daysDates[0]);
        } else {
          StoreUtils.commit("availability/setDailyTimeGroups", []);
          StoreUtils.commit("availability/setSelectedDate", null);
        }
      }
    );

    this.readProfModel.professionalId = professionalId;
    StoreUtils.dispatch(
      StoreUtils.actions.professional.READ_BY_PROFESSIONAL,
      this.readProfModel
    );
    this.readSubModel.subscriptionPlanProfessionalId = professionalId;
    StoreUtils.dispatch(
      "professional/readSubscriptionPlans",
      this.readSubModel
    );
    this.reviewListModel.professionalId = professionalId;
    StoreUtils.dispatch("professional/readReviews"), this.reviewListModel;

    this.readClassesModel.groupSessionProfessionalId = professionalId;
    StoreUtils.dispatch(
      "groupSession/readByProfessionalId",
      this.readClassesModel
    );
  },
  beforeMount() {
    let professionalReference = this.$route.params.professionalReference;
    this.refModel.professionalReference = professionalReference;
    if (this.$route.params.professionalPreference) {
      StoreUtils.dispatch("professional/readByReference", this.refModel);
    }
  }
};
</script>

<style scoped>
.skeleton-load {
  animation: skeleton-loading 1s linear infinite alternate;
  border-color: rgba(3, 28, 67, 0.1);
  border-radius: 8px;
  height: 40px;
  color: #031c43;
}

@keyframes skeleton-loading {
  0% {
    background-color: hsl(200, 20%, 93%);
  }
  100% {
    background-color: hsl(200, 20%, 98%);
  }
}

.empty-message-slot {
  font-size: 14px;
}

.image-wrapper {
  display: flex;
  height: 5.625rem;
  -webkit-box-align: center;
  align-items: center;
  -webkit-box-pack: justify;
  justify-content: space-between;
}

.image-wrap-head {
  width: 8.75rem;
  height: 8.75rem;
  flex: 0 0 8.75rem;
  position: relative;
  border-radius: 50%;
  margin-top: -3.125rem;
  border: 5px solid rgb(255, 255, 255);
  background-color: #f1f2f4;
}

.time-grid {
  display: grid;
  gap: 1rem;
  grid-template-columns: repeat(2, 1fr);
  /*grid-template-rows: repeat(1, 1fr);*/
  /*grid-template-columns: repeat(3, 1fr);*/
}
.to-alignment {
  align-self: center;
  position: relative;
  top: -10px;
}
.empty-times {
  margin-top: 20px;
  font-size: 14px;
}
.frequency-container {
  display: flex;
  width: 44%;
  /*justify-content: space-between;*/
  gap: 15px;
  border: 1px solid rgba(3, 28, 67, 0.1);
  border-radius: 8px;
  padding: 10px 15px;
  /*align-items: center;*/
  /*margin-bottom: 30px;*/
}
.frequency-1 {
  width: 50%;
  border: 1px solid rgba(3, 28, 67, 0.1);
  border-radius: 8px;
}
.frequency-2 {
  width: 50%;
  border: 1px solid rgba(3, 28, 67, 0.1);
  border-radius: 8px;
}
.check-container {
  width: 50%;
  margin-top: 22px;
}
.checks {
  display: flex;
  /*gap: 20px;*/
}
.stem-check {
  margin: 0;
  /*background-color: #0098da;*/
  /**/
  align-self: flex-start;
  display: flex;
}
.my-element-class {
  display: flex;
}

.stem-check label {
  /*margin-left: 0px;*/

  position: relative;
  top: 0px;
  right: 10px;
  /*background-color: #be8c8c;*/
  margin: 0;
}
.frequency-group {
  display: flex;
  /*justify-content: space-between;*/
  gap: 10px;
  font-family: "Galano grotesque-Light", sans-serif;
  color: #031c43;
  font-weight: 400;
  font-size: 14px;
  margin-bottom: 24px;
}
label {
  position: relative;
  top: 2px;
}
#subscription-1 label {
  font-weight: 400;
}
.subscription-button {
  margin-top: 0;
}
.subscription-div {
  border: none;
}
@media only screen and (max-width: 991px) {
  .frequency-container {
    width: 49%;
  }
}
</style>
